// src/App.jsx
import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

// Pages
import LoginPage from './pages/login';
import RegisterPage from './pages/register';
import MainPage from './pages/Main';
import QueuePage from './pages/Queue';
import PaymentPage from './pages/Payment';
import NotificationsPage from './pages/notifications';
import SettingsPage from './pages/settings';
import UserProfile from './pages/profil';
import PremiumPanel from './pages/PremiumPanel';
import SupportPage from './pages/Support';
import TrackingPage from './pages/Tracking';
import BuyurtmalarPage from './pages/Buyurtmalar';
import VerifyPage from './pages/verification';
import ResetPasswordPage from './pages/smscode';
import SetPasswordPage from './pages/setpassword';
import AuthCallback from './pages/AuthCallback';

// Admin panel
import DashboardLayout from './components/layout/DashboardLayout';
import AdminDashboard from './pages/AdminDashboard';
import AdminTrucks from './adminpanel/AdminTrucks';
import AdminPayments from './adminpanel/AdminPayments';
import AdminUsers from './adminpanel/AdminUsers';
import AdminQueue from './adminpanel/AdminQueue';
import AdminCylinders from './adminpanel/AdminCylinders';
import AdminRoutes from './adminpanel/AdminRoutes';
import AdminDriverTracking from './adminpanel/AdminDriverTracking';
import AdminStatistics from './adminpanel/AdminStatistics';

// Driver panel
import DriverDashboard from './pages/DriverDashboard';
import Roadmap from './driverpanel/roadmap';

// Operator panel
import OperatorDashboard from './pages/OperatorDashboard';

import ProtectedRoute from './components/ProtectedRoute';
import GuestRoute from './components/GuestRoute';


const App = () => {
  const { isBooting } = useAuth();

  if (isBooting) return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 dark:bg-[#0c1510]">
      <div className="flex flex-col items-center gap-4">
        <div className="h-16 w-16 bg-gradient-to-br from-[#1e9f6b] to-[#0d7a52] rounded-3xl flex items-center justify-center shadow-2xl shadow-[#1e9f6b]/40 animate-pulse">
          <span className="material-symbols-outlined text-white text-[32px]">local_gas_station</span>
        </div>
        <p className="text-slate-400 font-bold">SmartGaz yuklanmoqda...</p>
      </div>
    </div>
  );

  return (
    <>

      <Routes>
        {/* Public */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/login" element={<GuestRoute><LoginPage /></GuestRoute>} />
        <Route path="/register" element={<GuestRoute><RegisterPage /></GuestRoute>} />
        <Route path="/verify" element={<VerifyPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/set-password" element={<SetPasswordPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />

        {/* User routes */}
        <Route path="/main" element={<ProtectedRoute><MainPage /></ProtectedRoute>} />
        <Route path="/navbat" element={<ProtectedRoute><QueuePage /></ProtectedRoute>} />
        <Route path="/queue" element={<ProtectedRoute><QueuePage /></ProtectedRoute>} />
        <Route path="/tolov" element={<ProtectedRoute><PaymentPage /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><UserProfile /></ProtectedRoute>} />
        <Route path="/premium" element={<ProtectedRoute><PremiumPanel /></ProtectedRoute>} />
        <Route path="/support" element={<ProtectedRoute><SupportPage /></ProtectedRoute>} />
        <Route path="/tracking" element={<ProtectedRoute><TrackingPage /></ProtectedRoute>} />
        <Route path="/orders" element={<ProtectedRoute><BuyurtmalarPage /></ProtectedRoute>} />

        {/* Admin routes wrapped in DashboardLayout */}
        <Route element={<ProtectedRoute roles={['admin']}><DashboardLayout /></ProtectedRoute>}>
          <Route path="/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/statistics" element={<AdminStatistics />} />
          <Route path="/admin/trucks" element={<AdminTrucks />} />
          <Route path="/admin/payments" element={<AdminPayments />} />
          <Route path="/admin/users" element={<AdminUsers />} />
          <Route path="/admin/cylinders" element={<AdminCylinders />} />
          <Route path="/admin/queue" element={<AdminQueue />} />
          <Route path="/admin/routes" element={<AdminRoutes />} />
          <Route path="/admin/driver-tracking" element={<AdminDriverTracking />} />
        </Route>

        {/* Driver routes */}
        <Route path="/driver/dashboard" element={<ProtectedRoute roles={['driver', 'admin']}><DriverDashboard /></ProtectedRoute>} />
        <Route path="/driver/roadmap" element={<ProtectedRoute roles={['driver', 'admin']}><Roadmap /></ProtectedRoute>} />

        {/* Operator routes */}
        <Route path="/operator/dashboard" element={<ProtectedRoute roles={['operator', 'admin']}><OperatorDashboard /></ProtectedRoute>} />

        {/* 404 */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </>
  );
};

export default App;
